import {
    TICKETS_BY_NUMBER,
    TICKETS_BY_NUMBER_ERROR,
} from "_models/redux/types";

const initialState = {
    ticketsByNumber: [],
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case TICKETS_BY_NUMBER:
            return {
                ...state,
                ticketsByNumber: action.payload,
                loading: true,
            };

        case TICKETS_BY_NUMBER_ERROR:

        default:
            return state;
    }
}
